const { recommendRandomSort, formatImage, formatUrl } = require('@ifeng-fe/public_method');

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    formatOrderStream: ({ list }) => orderArr => {
        let checkFlag = true;

        const defaultOrderKey = list.map(item => item.orderKey);

        // 容错降级处理
        orderArr.forEach(orderPosKey => {
            if (!defaultOrderKey.includes(orderPosKey.id)) {
                checkFlag = false;
            }
        });

        if (checkFlag) {
            const returnOrderArr = [];
            orderArr.forEach(orderPosObj => {
                list.forEach(item => {
                    if (item.orderKey === orderPosObj.id) {
                        returnOrderArr.push(item);
                    }
                })
            });

            return returnOrderArr;
        } else {
            return list;
        }
    },
    formDataHotNews: data => {
        return recommendRandomSort(data, 3).map(item => ({
            ...item,
            title: item.title || '',
            summary: item.summary || '',
            url: item.url ? formatUrl(item.url) : '',
            src: item.thumbnail ? formatImage(item.thumbnail) : '',
        }));
    },
    formDataRecFirst: data => {
        let result = recommendRandomSort(data, 1);

        return result[0];
    },
    formDataRecSec: data => {
        const result = recommendRandomSort(data, 1);

        return result.map(item => ({
            type: item.type,
            id: item.id || '',
            summary: item.summary || '',
            source: item.source || '',
            thumbnailsCount: item.thumbnailsCount || '',
            title: item.title || '',
            url: item.url ? formatUrl(item.url) : '',
            newsTime: item.newsTime || '',
            thumbnails: item.thumbnails || false,
            thumbnail: item.thumbnail ? formatImage(item.thumbnail) : '',
        }))[0];
    },
    formDataRecThr: data => {
        return recommendRandomSort(data, 1).map(item => ({
            type: item.type,
            id: item.id || '',
            summary: item.summary || '',
            source: item.source || '',
            thumbnailsCount: item.thumbnailsCount || '',
            title: item.title || '',
            url: item.url ? formatUrl(item.url) : '',
            newsTime: item.newsTime || '',
            thumbnails: item.thumbnails || false,
            thumbnail: item.thumbnail ? formatImage(item.thumbnail) : '',
        }))[0];
    },
    handlePitSliderData: data => {
        return data.slice(0, 7).map(item => ({
            thumbnail: item.thumbnail ? formatImage(item.thumbnail,  1000, 539) : '',
            url: item.url ? formatUrl(item.url) : '',
            title: item.title || '',
            summary: item.summary || '',
        }));
    },
    handlePitProductsData: data => {
        return data.slice(0, 6).map(item => ({
            thumbnail: item.thumbnail ? item.thumbnail: '',
            url: item.url ? formatUrl(item.url) : '',
            title: item.title || '',
            summary: item.summary || '',
        }));
    },
};
